"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWebviewOwner = getWebviewOwner;
/**
 * When possible, determine the owner of the webview based on the user agent.
 *
 * If the user agent does not match a webview or the webview owner cannot be determined, return null.
 */
function getWebviewOwner(userAgent) {
    if (userAgent.includes("LinkedInApp")) {
        return "LinkedIn";
    }
    if (userAgent.includes("FBAN/FBIOS")) {
        return "Facebook";
    }
    if (userAgent.includes("Instagram")) {
        return "Instagram";
    }
    return null;
}
